var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToastCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4998 0.916504C11.9298 0.916504 0.916504 11.9298 0.916504 25.4998C0.916504 39.0698 11.9298 50.0832 25.4998 50.0832C39.0698 50.0832 50.0832 39.0698 50.0832 25.4998C50.0832 11.9298 39.0698 0.916504 25.4998 0.916504ZM25.4998 45.1665C14.6586 45.1665 5.83317 36.3411 5.83317 25.4998C5.83317 14.6586 14.6586 5.83317 25.4998 5.83317C36.3411 5.83317 45.1665 14.6586 45.1665 25.4998C45.1665 36.3411 36.3411 45.1665 25.4998 45.1665ZM20.5831 30.8345L35.0381 16.3795C35.9969 15.4208 37.5702 15.4208 38.529 16.3795C39.4877 17.3383 39.4877 18.887 38.529 19.8458L22.3286 36.0462C21.3698 37.0049 19.8211 37.0049 18.8623 36.0462L12.4952 29.6791C11.5365 28.7203 11.5365 27.1716 12.4952 26.2128C12.9545 25.7525 13.5781 25.4938 14.2283 25.4938C14.8786 25.4938 15.5022 25.7525 15.9615 26.2128L20.5831 30.8345Z",
    fill: "#CC1F1F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCheck);
export default __webpack_public_path__ + "static/media/toast-check.fafaf9e5a0667d4bbbd37970361efed5.svg";
export { ForwardRef as ReactComponent };